import { Component, Inject, Input, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import * as FileSaver from 'file-saver';
import { ToastrService } from 'ngx-toastr';
import { RMDClientFavouriteCarriersModel } from 'src/Models/RMDClientFavouriteCarriersModel';
import { RMDProviderFilterModel } from 'src/Models/RMDProviderFilterModel';
import { AppConfig } from 'src/Services/app.config';
import { CheckAuth } from '../../../../Services/utility.service';
import { ActionActivity, ToolEnum } from 'src/Models/Common';
import { ApplicationActivityStore } from 'src/common/commonFunction';
import { ApplicationActivityService } from 'src/Services/application-activity.service';
import { HtmlToPdf } from 'src/Services/htmlToPdf';
import { FrontRmdupdatesService } from 'src/Services/Frontrmdupdates.service';
import { FrontRMDUpdatesModel } from 'src/Models/FrontRMDUpdatesModel';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-rmdupdates',
  templateUrl: './rmdupdates.component.html',
  styleUrls: ['./rmdupdates.component.css']
})
export class FrontRMDUpdatesComponent implements OnInit {
  filter = new RMDProviderFilterModel();
  isShowprogressSpinner = false;
  blockedDocument = false;
  baseUrl: string;
  userID: number;
  isAscending: boolean = false
  upDownBussinessNameCSS: string = '';
  upDownImplementationCSS: string = '';
  upDownSys_updated_onCSS: string = '';
  upDownDescription_onCSS: string = '';
  carrier: FrontRMDUpdatesModel;
  rmdUpdatesModel: FrontRMDUpdatesModel[];
  rmdFullUpdatesModel: FrontRMDUpdatesModel[];
  tokenKey: string = '';
  isloading: boolean;
  appModel: any;
  lastModifiedDetails: '';
  carrierForm: FormGroup;
  totalRecordCount: number = -1;
  IsNotificationSaved: boolean = false;
  carrierId: number;
  isFavorite: boolean;
  rangeOfupdatesDates: any;
  rmdUnreadflag:boolean=true;
  rmdUnread: number = 0;

  constructor(private readonly htmlToPdf: HtmlToPdf, 
    private readonly rmdupdatesService: FrontRmdupdatesService, 
    private readonly toastr: ToastrService,
    private readonly titleService: Title, 
    private readonly checkAuth: CheckAuth,
    private readonly appActivity: ApplicationActivityService,
    @Inject('BASE_URL') baseUrl: string,
    private sessionStorageService: SessionStorageService) {
    this.baseUrl = baseUrl;
    this.tokenExpireCalculation(this.sessionStorageService.getAppStartTime(),this.sessionStorageService.getTokenExpiryValue());
    this.userID = +sessionStorage.getItem('UserId');
    //this.tokenKey = this.sessionStorageService.getTokenValue();
    this.appModel = AppConfig.settings.ConnectionStrings;

    // Try to get token
    this.waitForTokenThenInit();
  }

  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
    this.titleService.setTitle('Updates | JSi360');
  }

  private waitForTokenThenInit(): void {
    this.tokenKey = this.sessionStorageService.getTokenValue();

    if (!this.tokenKey) {
      console.warn('Token is empty, retrying in 100ms...');
      const interval = setInterval(() => {
        this.tokenKey = this.sessionStorageService.getTokenValue();
        if (this.tokenKey) {
          clearInterval(interval);
          this.afterTokenReady();
        }
      }, 100); // check every 100ms
    } else {
      this.afterTokenReady();
    }
  }

  /** Call what you normally do in ngOnInit */
  private afterTokenReady(): void {
    let rmdReadflag = sessionStorage.getItem('rmdUnreadflag');
    this.rmdUnreadflag = rmdReadflag === 'true' ? true : false;

    let rmdUnreadcount = sessionStorage.getItem('rmdUnread');

    this.rmdUnread = parseInt(rmdUnreadcount);

    this.movetotop();
    this.filter.orderBy = 'Sys_updated_on DESC';
    this.filter.userId = this.userID;
    this.filter.isFavorite = false;
    this.filter.pageNumber = 1;
    this.filter.pageSize = 10;
    this.filter.unreadonly = true;
    this.upDownSys_updated_onCSS = 'active';
    this.isAscending = true;
    this.GetCarriers();
  }

  ngOnInit() {
    
  }

  GetCarriers() {
    this.rmdUpdatesModel = [];
    this.rmdFullUpdatesModel = [];
    this.isloading = true;
    this.rmdupdatesService.GetRMDUpdatesUnread(this.tokenKey, this.filter).subscribe(
      data => {
        this.isloading = false;
        if (data != null) {
          sessionStorage.setItem('rmdUnreadflag', 'true');
          this.rmdUnreadflag = true;

          this.rmdUpdatesModel = data['updates'];
          if (this.rmdUpdatesModel != null) {
          ApplicationActivityStore('View', 'RMD - Updates', this.appActivity, ToolEnum.RMD, ActionActivity['Robocall Mitigation Database'], '/rmd/Update', null);
            
            if (this.rmdUpdatesModel.length > 0) {
              this.totalRecordCount = this.rmdUpdatesModel[0].totalRecordCount;
              this.filter.unreadonly = data.unreadonly;
              if (!data.unreadonly) {
                this.filter.pageSize = 10;
              }
              if (!this.IsNotificationSaved) {
                this.saveNotification(this.rmdUpdatesModel);
                this.IsNotificationSaved = true;
              }
            }
            else {
              this.totalRecordCount = 0;
            }
          }
          else {
            this.totalRecordCount = 0;
          }
        }
      },
      error => {
        this.isloading = false;
        console.log(error);
      }
    );

  }

  GetFullCarriers() {
    this.blockDocument();
    const filternew = Object.assign({}, this.filter);
    filternew.pageSize = 0;
    this.rmdupdatesService.GetFrontCarrierFilter(this.tokenKey, filternew).subscribe(
      data => {
        if (data != null) {
          this.rmdFullUpdatesModel = data['updates'];
          setTimeout(() => {
            let mainURL = this.baseUrl;
            let url = '<link id="adminstyle" rel="stylesheet" href="' + mainURL + '/assets/css/Admin/AdminLTE.min.css"> <br> ';
            url += ' <link rel="stylesheet" href="' + mainURL + '/assets/css/bootstrap.min.css" asp-append-version="true" /> <br> ';
            url += ' <link id="adminstyle" rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/js/bootstrap.min.js"> <br> ';
            var html = url + document.getElementById('divPrint').innerHTML;
            this.htmlToPdf.CreatePDF(this.tokenKey, html, '0',ToolEnum.RMD).
              subscribe(data => {
                if (data['status'] == 'Success') {
                  this.downloadFile('Providers', data['url']);
                }
              },
                error => {
                  this.unblockDocument();
                }
              );
          }, 10000);

        }
      },
      error => {
        console.log(error);
      }
    );

  }

  saveNotification(updates) {
    let carrierIds = updates.map(i => i.carrierId).join(',');
    const filter = new RMDProviderFilterModel();
    filter.userId = this.userID;
    filter.carrierIds = carrierIds;
    this.rmdupdatesService.addNotification(this.tokenKey, filter).subscribe(data => {
      if (data.status == 'Success') {
        sessionStorage.setItem('rmdUnreadflag','true');
        sessionStorage.setItem('rmdUnread','0');

      }
      else {
        this.showMessage(data.status, 'Error', 'error');
      }
    }, error => {
      this.showMessage(error, 'Error', 'error');
    });
  }

  updatesCarrierFilterClear() {
    this.filter.providerSearch = '';
    this.GetCarriers();
  }

  inputFilters($event, type) {
    if ($event.target.value != "" && $event.target.value != null)
      if (type == 1)
        this.filter.providerSearch = $event.target.value;
      else
        this.filter.keywordFilter = $event.target.value;
    else
      if (type == 1)
        this.filter.providerSearch = '';
      else
        this.filter.keywordFilter = '';
    this.filter.pageNumber = 1
    this.GetCarriers();
  }

  isUpdatesDatesFilter(value: any) {
    this.filter.pageNumber = 1;
    if (value != null) {
      if (value.length == 2) {
        this.filter.pageNumber = 1;
        const d = new Date(value[0]);
        const a = [this.pad(d.getMonth() + 1), this.pad(d.getDate()), d.getFullYear()].join('/');

        const e = new Date(value[1]);
        const f = [this.pad(e.getMonth() + 1), this.pad(e.getDate()), e.getFullYear()].join('/');

        this.filter.fromDate = a;
        this.filter.todate = f;
        this.GetCarriers();
      }
    }
  }

  pad(s) {
    return (s < 10) ? '0' + s : s;
  }

  updatesDateFilterClear() {
    this.rangeOfupdatesDates = [];
    this.filter.fromDate = '';
    this.filter.todate = '';
    this.GetCarriers();
  }
  GetFavourite(IsFavourite: boolean) {
    this.filter.pageNumber = 1;
    this.filter.isFavorite = IsFavourite;
    this.GetCarriers();
  }


  cleanCssClass() {
    this.upDownBussinessNameCSS = '';
    this.upDownDescription_onCSS = '';
    this.upDownImplementationCSS = '';
    this.upDownSys_updated_onCSS = '';
  }

  sort(sortBy: any) {
    this.cleanCssClass();
    this.isAscending = !this.isAscending;
    this.filter.orderBy = this.isAscending ? sortBy : sortBy + ' DESC';

    switch (sortBy) {
      case "Business_name": this.upDownBussinessNameCSS = this.isAscending ? 'active' : 'active-up'; break;
      case "Description": this.upDownDescription_onCSS = this.isAscending ? 'active' : 'active-up'; break;
      case "Implementation": this.upDownImplementationCSS = this.isAscending ? 'active' : 'active-up'; break;
      case "Sys_updated_on": this.upDownSys_updated_onCSS = this.isAscending ? 'active' : 'active-up'; break;
      default: break;
    }
    this.filter.pageNumber = 1;
    this.GetCarriers();
  }

  GetRMDUpdateById(carrierId) {
    this.carrier = undefined;
    this.blockDocument();
    this.rmdupdatesService.GetRMDUpdatesFindByCarrierID(this.tokenKey, carrierId).subscribe(
      data => {
        this.unblockDocument();
        if (data != null) {
          this.carrier = data['updates'];
          ApplicationActivityStore('View', 'RMD - Updates', this.appActivity, ToolEnum.RMD, ActionActivity['Robocall Mitigation Database'], '/rmd/Update/details', null);

        }
      },
      error => {
        this.unblockDocument();
        console.log(error);
      }
    );

  }
  pageChanged($event: any) {
    this.filter.pageNumber = $event.page;
    this.GetCarriers();
  }

  AddToFavourite(id: number, isFavorite: boolean) {
    this.carrierId = id;
    this.isFavorite = isFavorite;
    if (!isFavorite) {
      var elem = document.getElementById("lnkFavouriteValidation");
      elem.click();
    }
    else {
      this.SaveFavoriteProvider();
    }
  }

  SaveFavoriteProvider() {
    const favouriteCarriersModel = new RMDClientFavouriteCarriersModel();
    favouriteCarriersModel.clientId = this.userID;
    favouriteCarriersModel.isFavourite = this.isFavorite;
    favouriteCarriersModel.carrierId = this.carrierId;
    this.rmdupdatesService.RMDClientCarrierFavouriteAddRemove(this.tokenKey, favouriteCarriersModel)
      .subscribe(data => {
        if (data["status"] == "Success") {
          this.rmdUpdatesModel.filter(x => x.carrierId == this.carrierId).forEach(element => {
            element.isFavorite = this.isFavorite;
          });
          if (this.isFavorite) {
            this.showMessage('Selected provider added successfully to favorite list.', 'Favorite', 'success');
          }
          else {
            this.showMessage('Selected provider removed successfully from favorite list.', 'Favorite', 'success');
          }
          document.getElementById("btnClose").click();
        }
        else {
          this.showMessage(data["status"], 'Error', 'error');
        }

      }, error => {
        this.showMessage(error, 'Error', 'error');
      })
  }


  pdfDocument() {
    this.GetFullCarriers();
  }

  public downloadFile(filename, url) {
    this.htmlToPdf.downloadPdf(url).subscribe(
      (res) => {
        FileSaver.saveAs(res, filename);
        ApplicationActivityStore('Download', 'RMD Updates File download ' + filename, this.appActivity, ToolEnum.RMD, ActionActivity['Robocall Mitigation Database'], '/rmd/updates/Details');

        sessionStorage.setItem('fileloading', 'false');
        this.unblockDocument();
      }
    );
  }

  blockDocument() {
    this.isShowprogressSpinner = true;
    this.blockedDocument = true;
  }
  unblockDocument() {
    this.isShowprogressSpinner = false;
    this.blockedDocument = false;
  }
  showMessage(msg: string, msgTitle: string, msgType: string) {
    if (msgType == 'success') {
      setTimeout(() => this.toastr.success(msg, msgTitle));
    }
    else if (msgType == 'error') {
      setTimeout(() => this.toastr.error(msg, msgTitle));
    }
  }
  movetotop() {
    let scrollToTop = window.setInterval(() => {
      let pos = window.pageYOffset;
      if (pos > 0) {
        window.scrollTo(0, pos - 20); // how far to scroll on each step
      } else {
        window.clearInterval(scrollToTop);
      }
    }, 1);
  }

  ngAfterViewInit() {
    this.setEmailAutoLoginParameter();
  }
  
  setEmailAutoLoginParameter() {
      if (sessionStorage.getItem('DisplayMessage') != null) {
        this.showMessage(sessionStorage.getItem('DisplayMessage') + ' - user not have access', 'Error', 'error');
        sessionStorage.removeItem('DisplayMessage');
      }
  }
}
